export default __webpack_public_path__ + "static/media/calendarBlue.fe86eee7.svg";